"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWithMetadata = exports.mapWallItemFromWallItemEvents = exports.accumulateAndTransformWallEvents = exports.accumulateAndMapWallEvents = exports.excludeByProperty = exports.filterByProperty = exports.findInGroup = void 0;
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const guards_1 = require("./guards");
function findInGroup(value) {
    return (0, operators_1.find)(g => g.key === value);
}
exports.findInGroup = findInGroup;
function filterByProperty(property, value) {
    return (0, operators_1.map)(wallItems => wallItems.filter(item => item[property] === value));
}
exports.filterByProperty = filterByProperty;
function excludeByProperty(property, value) {
    return (0, operators_1.map)(wallItems => wallItems.filter(item => item[property] !== value));
}
exports.excludeByProperty = excludeByProperty;
function accumulateAndMapWallEvents(type) {
    return accumulateAndTransformWallEvents(type);
}
exports.accumulateAndMapWallEvents = accumulateAndMapWallEvents;
function accumulateAndTransformWallEvents(type, transform) {
    return (0, operators_1.mergeMap)(g => g.pipe((0, operators_1.mergeScan)((acc, cur) => __awaiter(this, void 0, void 0, function* () {
        const idx = acc.findIndex(i => cur.itemId === i.id);
        if (cur.type === 'DELETED') {
            (0, toolbox_1.invariant)(idx >= 0, 'Tried to delete non-existent item');
            acc.splice(idx, 1);
            return acc;
        }
        let item = type
            ? mapWithMetadata(cur.item, type)
            : cur.item;
        if (transform) {
            item = yield transform(item);
        }
        if (idx >= 0) {
            acc.splice(idx, 1, item);
        }
        else {
            acc.push(item);
        }
        return acc;
    }), [])));
}
exports.accumulateAndTransformWallEvents = accumulateAndTransformWallEvents;
function mapWallItemFromWallItemEvents(type) {
    return (0, operators_1.switchMap)(g => g.pipe((0, operators_1.map)(e => e.type === 'DELETED' ? undefined : type ? mapWithMetadata(e.item, type) : e.item)));
}
exports.mapWallItemFromWallItemEvents = mapWallItemFromWallItemEvents;
function mapWithMetadata(item, type) {
    (0, toolbox_1.invariant)(typeof item[type] === 'object');
    if ((0, guards_1.isWallItem)(item)) {
        return Object.assign({
            id: item.id,
            ownerUserId: item.ownerUserId,
            ownerDeviceId: item.ownerDeviceId,
            clientCreatedAt: item.clientCreatedAt,
        }, item[type]);
    }
    else if ((0, guards_1.isUserWallItem)(item)) {
        return Object.assign({
            id: item.id,
            ownerDeviceId: item.ownerDeviceId,
            clientCreatedAt: item.clientCreatedAt,
        }, item[type]);
    }
    throw new Error('Unable to determine WallItemType');
}
exports.mapWithMetadata = mapWithMetadata;
//# sourceMappingURL=utils.js.map